import styled, { css } from 'styled-components'
import { Tokens } from '@/assets/tokens'
import { blinkingAnimation } from '@/components/derived/ManualCard/ManualCard.animations'

export const PolarityContent = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: 0;
  overflow: visible;
`

export const PolarityHeader = styled.div<{ $expanded: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background-color: ${Tokens.ColorBackground};
  cursor: ${({ $expanded }) => ($expanded ? 'default' : 'pointer')};
  flex-shrink: 0;
  border-radius: 12px 12px 0 0;
`

export const PolarityTitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 16px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
`

export const PolarityStatusSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const SmallPolarityEmoji = styled.div`
  transform: scale(0.8);
  transform-origin: center;
`

export const ViewRulesButton = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background-color: ${Tokens.ColorWhite};
  border: 1px solid ${Tokens.ColorBorder};
  border-radius: 6px;
  font-size: 14px;
  color: ${Tokens.ColorTextSecondary};
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover {
    background-color: ${Tokens.ColorHover};
    border-color: ${Tokens.ColorUIPrimary};
    color: ${Tokens.ColorUIPrimary};
  }
`

export const PolarityTermsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: ${Tokens.ColorBackground};
  flex: none;
`

export const TermsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 16px;
`

export const TermSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const RulesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  flex: none;
  min-height: 0;
  overflow: visible;
  background-color: ${Tokens.ColorBackground};

  &:last-child {
    border-radius: 0 0 12px 12px;
  }
`

export const RulesTitleWithCounter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const RulesTitleWithStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const RulesTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: ${Tokens.ColorTextPrimary};
  margin: 0;
  flex-shrink: 0;
`

export const RulesCountSpan = styled.span`
  font-size: 12px;
  color: #666;
`

export const RulesTextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  max-height: 200px;
  padding: 12px;
  border: 1px solid #dee2ef;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;
  overflow-y: auto;

  &:focus {
    outline: none;
    border-color: #01c38d;
  }

  &::placeholder {
    color: #9ca3af;
  }
`

export const RulesValidationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const HealthCheckStatus = styled.div<{ $status: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 2px solid ${Tokens.ColorUIPrimaryDim};
  box-shadow: 0 0 6px ${Tokens.ColorUIPrimaryDim};
  background-color: ${Tokens.ColorUIPrimary};

  ${({ $status }) =>
    !$status &&
    css`
      border: 2px solid ${Tokens.ColorUIDangerDim};
      box-shadow: 0 0 6px ${Tokens.ColorUIDangerDim};
      background-color: ${Tokens.ColorUIDanger};
      animation: ${blinkingAnimation} 1s ease-in-out infinite;
    `}
`
